import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { responsiveFontSizes } from '@mui/material/styles';

import { theme } from '../theme';

type ThemeProviderProps = {
  children: React.ReactNode;
};

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const responsiveFontTheme = responsiveFontSizes(theme);
  return <MUIThemeProvider theme={responsiveFontTheme}>{children}</MUIThemeProvider>;
};
